/*
/ Development server:
/ npm run serve
/
/ Commit:
/ git add -A
/ git commit -m ""
/ git push origin
/
/ Deploy:
/ https://cli.vuejs.org/guide/deployment.html
/ npm run build
/ firebase deploy
/
*/

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import * as firebase from "firebase/app";
import "firebase/auth";
import "bulma/css/bulma.css";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // Allows for persistence
    firebase.auth().onAuthStateChanged(function(user) {
      if (user) {
        // User is signed in.
        store.commit("setUser", user);
        store.commit("setIsAuthenticated", true);
      } else {
        // User signed out.
        store.commit("setUser", null);
        store.commit("setIsAuthenticated", false);
      }
    });
  }
}).$mount("#app");
